var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.75C6.75 11.1424 7.30312 12.4777 8.28769 13.4623C9.27226 14.4469 10.6076 15 12 15C13.3924 15 14.7277 14.4469 15.7123 13.4623C16.6969 12.4777 17.25 11.1424 17.25 9.75C17.25 8.35761 16.6969 7.02226 15.7123 6.03769C14.7277 5.05312 13.3924 4.5 12 4.5C10.6076 4.5 9.27226 5.05312 8.28769 6.03769C7.30312 7.02226 6.75 8.35761 6.75 9.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9129 20.876C18.0071 19.9645 16.93 19.2412 15.7436 18.7476C14.5572 18.254 13.2849 17.9998 11.9999 17.9998C10.7149 17.9998 9.44261 18.254 8.25619 18.7476C7.06978 19.2412 5.9927 19.9645 5.08691 20.876",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.da90f5fd11c610bf5bd6038d488e0b80.svg";
export { ForwardRef as ReactComponent };